<template>
  <el-dialog
    :visible="signInDialogVisible"
    :close-on-click-modal="false"
    width="360px"
    top="25vh"
    class="dialog-sign-in"
    @close="onCloseDialog"
  >
    <iframe
      v-if="qrCodeVisible"
      :src="signInURL"
      title="WeChat QR code for sign in"
      scrolling="no"
      class="dialog-sign-in__qr-code"
    ></iframe>
    <p v-else-if="weChatTipVisible" class="dialog-sign-in__tip">
      请使用微信内置浏览器访问！
    </p>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "DialogSignIn",
  computed: {
    ...mapState([
      "signInURL",
      "signInDialogVisible",
      "qrCodeVisible",
      "weChatTipVisible",
    ]),
  },
  methods: {
    ...mapMutations(["setSignInDialogVisible"]),

    onCloseDialog() {
      this.setSignInDialogVisible(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-sign-in {
  ::v-deep .el-dialog__body {
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 160px;
    font-size: 16px;

    .dialog-sign-in__qr-code {
      width: 300px;
      height: 340px;
      border: none;
    }
  }
}
</style>